export default __webpack_public_path__ + "static/media/team9.718fd365.png";